// @flow
import type {ApplicationRedux} from 'redux/ApplicationRedux';
import type {DataState} from 'redux/v1/travelers/data/DataState';
import type {FormState} from 'redux/v1/travelers/form/FormState';
import type {PutState} from 'redux/v1/travelers/put/PutState';

import {travelerState} from 'redux/v1/V1State';

export type TravelersState = {
  data: DataState,
  put: PutState,
  form: FormState,
};

export const dataState = (state: ApplicationRedux): DataState =>
  travelerState(state).data;

export const putState = (state: ApplicationRedux): PutState =>
  travelerState(state).put;

export const formState = (state: ApplicationRedux): FormState =>
  travelerState(state).form;
